module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":"Email","multiple emails possible":"multiple emails possible"},"de":{"email":"Email","multiple emails possible":"mehrere Emails möglich"}}')
  delete Component.options._Ctor
}
